import { defaultObj } from './state'

export default {
  updateVehicleInformation (state, data) {
    if (data.userIsTitleHolder !== undefined) {
      state.userIsTitleHolder = data.userIsTitleHolder
    }

    if (data.titleAddress !== undefined) {
      state.titleAddress = data.titleAddress
    }

    if (data.state !== undefined) {
      state.state = data.state
    }

    if (data.customerEstimate !== undefined) {
      state.customerEstimate = data.customerEstimate
    }

    if (data.estimatePercent !== undefined) {
      state.estimatePercent = data.estimatePercent
    }

    if (data.description !== undefined) {
      state.description = data.description
    }

    if (data.year !== undefined) {
      state.year = data.year
    }

    if (data.make !== undefined) {
      state.make = data.make
    }

    if (data.model !== undefined) {
      state.model = data.model
    }

    if (data.series !== undefined) {
      state.series = data.series
    }

    if (data.style !== undefined) {
      state.style = data.style
    }

    if (data.vehicleMileage !== undefined) {
      state.vehicleMileage = data.vehicleMileage
    }

    if (data.description !== undefined) {
      state.description = data.description
    }

    if (data.year !== undefined) {
      state.year = data.year
    }

    if (data.make !== undefined) {
      state.make = data.make
    }

    if (data.model !== undefined) {
      state.model = data.model
    }

    if (data.series !== undefined) {
      state.series = data.series
    }

    if (data.style !== undefined) {
      state.style = data.style
    }

    if (data.vehicleMileage !== undefined) {
      state.vehicleMileage = data.vehicleMileage
    }

    if (data.brokenOdometer !== undefined) {
      state.brokenOdometer = data.brokenOdometer
    }

    if (data.lienHolderName !== undefined) {
      state.lienHolderName = data.lienHolderName
    }

    if (data.lienHolderPhone !== undefined) {
      state.lienHolderPhone = data.lienHolderPhone
    }

    if (data.lienHolderAccountNumber !== undefined) {
      state.lienHolderAccountNumber = data.lienHolderAccountNumber
    }

    if (data.estimatedPayoffAmount !== undefined) {
      state.estimatedPayoffAmount = data.estimatedPayoffAmount
    }

    if (data.vehicleEstimate !== undefined) {
      state.vehicleEstimate = data.vehicleEstimate
    }

    if (data.hasCoOwner !== undefined) {
      state.hasCoOwner = data.hasCoOwner
    }

    if (data.coOwnerFirstName !== undefined) {
      state.coOwnerFirstName = data.coOwnerFirstName
    }

    if (data.coOwnerMiddleName !== undefined) {
      state.coOwnerMiddleName = data.coOwnerMiddleName
    }

    if (data.coOwnerLastName !== undefined) {
      state.coOwnerLastName = data.coOwnerLastName
    }

    if (data.coOwnerSuffixName !== undefined) {
      state.coOwnerSuffixName = data.coOwnerSuffixName
    }

    if (data.registrationCounty !== undefined) {
      state.registrationCounty = data.registrationCounty
    }
  },

  setRegistrationCounty (state, data) {
    state.registrationCounty = data.registrationCounty
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
  }
}
